import { render, staticRenderFns } from "./RMAFooter.vue?vue&type=template&id=3a65b4a3&scoped=true&"
import script from "./RMAFooter.vue?vue&type=script&lang=js&"
export * from "./RMAFooter.vue?vue&type=script&lang=js&"
import style0 from "./RMAFooter.vue?vue&type=style&index=0&id=3a65b4a3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a65b4a3",
  null
  
)

export default component.exports